<template>
  <b-modal
    ref="bModal"
    :title="$tc('component.userDowntimeModal.title')"
    centered
    modal-class="userDowntimeModal"
    @hide="onHide($event)"
  >
    <b-row class="text-center">
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <i
          class="main fa-2x far fa-sign-out-alt"
          aria-hidden="true"
        />
        <span class="mt-3">{{ $tc('component.userDowntimeModal.userDowntimeLimit') }}</span>
        <h1 class="primary-dark-color">
          {{ timeToDowntimeInSeconds }}
        </h1>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            qa="userDowntimeModal-logout"
            @click="logOut()"
          >
            {{ $tc('component.userDowntimeModal.logOut') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            qa="userDowntimeModal-continue"
            @click="continueLogged()"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $tc('component.userDowntimeModal.continue') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { auth } from '@/api/auth'
import moment from 'moment'

export default {
    name: 'UserDowntimeModal',
    data() {
        return {
            duration: null,
            interval: null,
            countDownInterval: null,
            timeToDowntimeInSeconds: ''
        }
    },
    methods: {
        show(timeToDowntimeInSeconds) {
            this.$refs.bModal.show()
            this.duration = moment.duration(timeToDowntimeInSeconds * 1000)
            this.timeToDowntimeInSeconds = this.duration.hours() + 'h:' + this.duration.minutes() + 'm:' + this.duration.seconds() + 's'
            this.interval = 1000
            this.countDownInterval = setInterval(this.countDown, this.interval)
        },
        onHide(evt) {
            if (evt && (evt.trigger === 'backdrop' || evt.trigger === 'esc' || evt.trigger === 'headerclose')) {
                this.continueLogged()
            }
        },
        hide() {
            this.$refs.bModal.hide()
        },
        continueLogged() {
            auth.resetUserDowntimeTimeout()
            this.cancelCountDownInterval()
            this.hide()
        },
        logOut() {
            this.hide()
            auth.logOut()
        },
        countDown() {
            this.duration = moment.duration(this.duration.asMilliseconds() - this.interval, 'milliseconds')
            this.timeToDowntimeInSeconds = this.duration.hours() + 'h:' + this.duration.minutes() + 'm:' + this.duration.seconds() + 's'

            if (!this.$store.getters.userLoggedIn || this.duration.asSeconds() <= 0) {
                clearInterval(this.countDownInterval)
                this.duration = null
                this.interval = null
                this.countDownInterval = null
                this.logOut()
            }
        },
        cancelCountDownInterval() {
            clearInterval(this.countDownInterval)
        }
    }
}
</script>

<style lang="scss">
.userDowntimeModal .modal-body {
  padding: 20px 10px;
}

.userDowntimeModal .modal-dialog {
  max-width: 25%;
  min-width: 370px;
}

@media (max-width: 1300px) {
  .userDowntimeModal .modal-dialog {
    max-width: 25%;
  }
}
</style>

<style lang="scss" scoped>
.userDowntimeModal span {
  font-size: font-size(very-normal);
}
</style>
